/**
 * useAIFilingPayment.js
 * =====================
 * Bridges Phase 1 payment completion → Phase 2 AI filing session creation.
 */

import { useState }    from 'react';
import { useNavigate } from 'react-router-dom';
import { toast }       from 'sonner';
import axios           from 'axios';

const CF_WORKER_URL = process.env.REACT_APP_AI_WORKER_URL;

const aiApi = axios.create({ baseURL: CF_WORKER_URL });
aiApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token') || localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function useAIFilingPayment() {
  const navigate  = useNavigate();
  const [creating, setCreating] = useState(false);

  const createAISession = async (filingRequest, amountPaid) => {
    setCreating(true);
    try {
      const res = await aiApi.post('/api/ai-filing/session', {
        financial_year:    filingRequest.financial_year,
        amount_paid:       amountPaid || filingRequest.price || 0,
        phase1_request_id: filingRequest.id,
      });
      toast.success('Payment confirmed! Your AI filing session is ready.');
      navigate(`/ai-filing?session=${res.data.session_id}`, { replace: true });
    } catch {
      toast.error('Payment confirmed but could not start session. Go to AI Filing to continue.');
      navigate('/ai-filing', { replace: true });
    } finally {
      setCreating(false);
    }
  };

  return { createAISession, creating };
}

export function isAIFilingPlan(plan) {
  if (!plan) return false;
  return (
    plan.plan_type === 'ai_filing' ||
    plan.name?.toLowerCase().includes('ai filing') ||
    plan.name?.toLowerCase().includes('ai based') ||
    plan.name?.toLowerCase().includes('ai tax')
  );
}
